import React, { useEffect } from "react";
import { useAppSelector } from "../../hooks/store-hooks";
import { useLazyGetUserByIdDataQuery } from "../../store/api/userApi";
import RightBar from "../../components/Home/right-side-bar";
import LeftBar from "../../components/Home/left-side-bar";
import ActivityContent from "../../components/Home/main-content/activity";

const ActivityPage = () => {
  const { homeData } = useAppSelector((state: any) => state.home ?? {});

  const user = homeData?.user ?? {};

  const [trigger] = useLazyGetUserByIdDataQuery();

  useEffect(() => {
    if (user?._id) {
      trigger({ userId: user?._id });
    }
  }, [user?._id]);

  return (
    <div className="bg-gray-100 h-full w-full relative">
      <div className="p-4">
        <div className="mx-5 grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Sidebar */}
          <LeftBar />

          {/* Main Content */}
          <ActivityContent />

          {/* Right Sidebar */}
          <RightBar />
        </div>
      </div>
    </div>
  );
};

export default ActivityPage;
